import type { EvidenceTagKind } from "../data/evidenceTags";
import { EVIDENCE_TAG_LABELS } from "../data/evidenceTags";

const TAG_STYLES: Record<EvidenceTagKind, string> = {
  NORMATIVO: "bg-[#1f4e5f] text-white",
  EVIDENCIA: "bg-[#2f6364] text-white",
  DISEÑO: "bg-[#6b5b3e] text-white",
  SIMULADO: "bg-[#7a5c2e] text-white",
  "POR VERIFICAR": "bg-[#8a3b3b] text-white",
};

export function EvidenceTag({ kind }: { kind: EvidenceTagKind }) {
  return (
    <span
      className={`inline-block rounded-full px-2.5 py-0.5 text-xs font-semibold tracking-wide ${TAG_STYLES[kind]}`}
      aria-label={`Etiqueta probatoria: ${EVIDENCE_TAG_LABELS[kind]}`}
    >
      {kind}
    </span>
  );
}
